import PasswordLinkExpired from './PasswordLinkExpired';

export default PasswordLinkExpired;